import React, { useRef,useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { TEXT } from './custom_authentication/CustomAuthUtils';
import { Toast } from 'primereact/toast';
import { ManageUsersService } from "../components/manage_users/service/ManageUserService";

function UserSettings({ userData, setrefreshUsersTab }) {
  const [user, setUser] = useState();
  const [actionDialog, setActionDialog] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [frequency, setFrequency] = useState('OFF');
  const hideDialog = () => setActionDialog(false);
  const toast = useRef(null);
  const notificationSettings = { AUTH_NOTIFICATION: frequency };

  const openSettings = async () => {
    setActionDialog(true);
    const targetUser = await fetchTargetUser(userData);

    if (!targetUser) {
      displayToastMessage(TEXT.ERROR, "Target user not found.");
      return;
    }

    let notifRaw = targetUser.data['custom:portal_notification'];
    let notifObj;
    
    if (notifRaw === undefined) {
      notifObj = { AUTH_NOTIFICATION: "DAILY" };
    } else {
      try {
        notifObj =
          typeof notifRaw === "string" ? JSON.parse(notifRaw) : notifRaw;
      } catch {
        notifObj = { AUTH_NOTIFICATION: "OFF" };
      }
    }
   
    const freq = notifObj?.AUTH_NOTIFICATION || "OFF";
    setNotificationsEnabled(freq !== "OFF");
    setFrequency(freq);
    setUser(targetUser);
  };

  const saveSettings = async () => {
    try {
      const targetUser = await fetchTargetUser(userData);
      console.log("Saving user settings:", targetUser);
      if (!targetUser) {
        displayToastMessage(TEXT.ERROR, "Target user not found.");
        return;
      }

      const notificationSettings = { AUTH_NOTIFICATION: frequency };

      const userDataValues = {
        email: targetUser.data.email,
        portal_notification: JSON.stringify(notificationSettings),
      };

      console.log("Saving user settings:", userDataValues);

      const response = await ManageUsersService.updateAuthNotification(
        userDataValues
      );
      const { statusCode, data: respData } = response;

      if (statusCode === 200 && respData) {
        displayToastMessage(TEXT.SUCCESS, "Settings saved successfully.");
        setrefreshUsersTab(prev => prev + 1);
      } else {
        displayToastMessage(TEXT.ERROR, "Failed to save the settings.");
      }

      // Reset to defaults
      setActionDialog(false);
      setNotificationsEnabled(false);
      setFrequency("OFF");
    } catch (error) {
      console.error("Error saving settings:", error);
      displayToastMessage(TEXT.ERROR, "Failed to save the settings.");
    }
  };
  
  const fetchTargetUser = async (userData) => {
    try {
      // use email as filter
      const response = await ManageUsersService.getUserByEmail(userData?.attributes?.email);

      return response;
    } catch (error) {
      console.error("Error fetching target user:", error);
      return null;
    }
  };


  const displayToastMessage = (severity, message) => {
    let errorClass =
      severity === TEXT.ERROR ? TEXT.FAILURE_TOAST : TEXT.SUCCESS_TOAST;
    let toastMessage = {
      severity: severity,
      life: 3000,
      summary: message,
      className: errorClass,
    };
    toast.current.show(toastMessage);
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      {/* Button with icon*/}
      <Button
        icon="pi pi-cog"
        className="user-settings-button"
        onClick={openSettings}
        data-testid="user-settings"
      />

      <Dialog
        visible={actionDialog}
        header="Settings"
        modal
        className="p-fluid dialog-div-settings"
        onHide={hideDialog}
        closable={true}
      >
        <div className="settings-container">
          <div className="notification-section">
            <label>Notifications</label>
            <InputSwitch
              checked={notificationsEnabled}
              onChange={(e) => {
                const enabled = e.value;
                setNotificationsEnabled(enabled);
                if (!enabled) {
                  // toggle OFF → frequency = OFF
                  setFrequency("OFF");
                } else {
                  // toggle ON → default to DAILY unless user changes to WEEKLY
                  setFrequency("DAILY");
                }
              }}
            />
          </div>

          <div className="frequency-section">
            <label>
              <input
                type="radio"
                name="frequency"
                value="DAILY"
                checked={frequency === "DAILY"}
                onChange={() => setFrequency("DAILY")}
                disabled={!notificationsEnabled}
              />
              DAILY (M-F)
            </label>
            <label>
              <input
                type="radio"
                name="frequency"
                value="WEEKLY"
                checked={frequency === "WEEKLY"}
                onChange={() => setFrequency("WEEKLY")}
                disabled={!notificationsEnabled}
              />
              WEEKLY (MON)
            </label>
          </div>
        </div>
        <div className="btn-container">
          <button onClick={saveSettings} data-testid="save-settings">
            Save
          </button>
        </div>
      </Dialog>
    </>
  );
}

UserSettings.propTypes = {
  userData: PropTypes.any,
  setrefreshUsersTab: PropTypes.func
};

export default UserSettings;
